import React, { useState } from "react";
import ContactForm from "../../Components/ContactForm/ContactForm";
import products from "../../data/products.json";

export const Header = ({ transparent = false }) => {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <header
      className={`w-full px-6 py-4 z-50 transition-all duration-300 ${
        transparent
          ? "absolute top-0 left-0 bg-transparent text-white"
          : "bg-gray-100 text-black shadow-md sticky top-0"
      }`}
    >
      <div className="max-w-7xl mx-auto flex justify-between items-center">

        {/* Logo */}
        <a href="/">
          <img
             src={transparent ? "/staticImages/logo-white.png" : "/staticImages/logo.png"}
            alt="Gradiance Logo"
            className="h-14 md:h-16"
            loading="eager"
          />
        </a>

        {/* Desktop Nav */}
        <nav className="hidden md:flex space-x-6 text-lg font-medium">
          <a
            href="/"
            className={
              transparent
                ? "hover:text-orange-300 transition"
                : "hover:text-orange-700 transition"
            }
          >
            Home
          </a>

          <a
            href="/Gallery"
            className={
              transparent
                ? "hover:text-orange-300 transition"
                : "hover:text-orange-700 transition"
            }
          >
            Gallery
          </a>

          <a
            href="/AboutUs"
            className={
              transparent
                ? "hover:text-orange-300 transition"
                : "hover:text-orange-700 transition"
            }
          >
            About Us
          </a>

          <a
            href="/ContactUs"
            className={
              transparent
                ? "hover:text-orange-300 transition"
                : "hover:text-orange-700 transition"
            }
          >
            Contact Us
          </a>
        </nav>

        {/* Hamburger */}
        <button
          className="md:hidden focus:outline-none"
          onClick={() => setIsOpen(!isOpen)}
          aria-label="Toggle navigation menu"
        >
          <svg
            className="w-7 h-7"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            viewBox="0 0 24 24"
          >
            {isOpen ? (
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M6 18L18 6M6 6l12 12"
              />
            ) : (
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M4 6h16M4 12h16M4 18h16"
              />
            )}
          </svg>
        </button>
      </div>

      {/* Mobile Menu */}
      {isOpen && (
        <div
          className={`md:hidden mt-4 space-y-4 px-4 pb-4 text-base ${
            transparent
              ? "bg-black/40 backdrop-blur-md rounded-lg p-4"
              : ""
          }`}
        >
          <a
            href="/"
            className={
              transparent
                ? "block hover:text-orange-300"
                : "block hover:text-orange-700"
            }
          >
            Home
          </a>

          <a
            href="/Gallery"
            className={
              transparent
                ? "block hover:text-orange-300"
                : "block hover:text-orange-700"
            }
          >
            Gallery
          </a>

          <a
            href="/AboutUs"
            className={
              transparent
                ? "block hover:text-orange-300"
                : "block hover:text-orange-700"
            }
          >
            About Us
          </a>

          <a
            href="/ContactUs"
            className={
              transparent
                ? "block hover:text-orange-300"
                : "block hover:text-orange-700"
            }
          >
            Contact Us
          </a>
        </div>
      )}
    </header>
  );
};

export const Footer = () => {
  return (
    <footer className="bg-gray-100 text-black px-6 pt-10 pb-6 mt-20">
      <div className="max-w-6xl mx-auto grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-10 text-center md:text-left">
        {/* Left: Quick Links */}
        <div>
          <h4 className="text-lg font-semibold mb-3">Quick Links</h4>
          <ul className="space-y-2 text-sm">
            <li>
              <a href="/PrivacyPolicy" className="hover:text-orange-700">
                Privacy Policy
              </a>
            </li>
            <li>
              <a href="/TermsAndConditions" className="hover:text-orange-700">
                Terms & Conditions
              </a>
            </li>
            <li>
              <a href="/ContactUs" className="hover:text-orange-700">
                Contact
              </a>
            </li>
          </ul>
        </div>

        {/* Center: Social Media */}
        <div className="flex flex-col items-center md:items-center">
          <h4 className="text-lg font-semibold mb-3">Follow Us</h4>
          <div className="flex gap-4 justify-center">
            {/* Instagram */}
            <a
              href="https://www.instagram.com/gradiance.in"
              target="_blank"
              rel="noopener noreferrer"
              className="p-2 rounded-full bg-gray-200 hover:bg-orange-100 transition"
            >
              <svg
                width="26"
                height="26"
                viewBox="0 0 15 15"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M7.5 5C6.12 5 5 6.12 5 7.5C5 8.88 6.12 10 7.5 10C8.88 10 10 8.88 10 7.5C10 6.12 8.88 5 7.5 5Z"
                  fill="#000"
                />
                <path
                  fillRule="evenodd"
                  clipRule="evenodd"
                  d="M4.5 0C2.01 0 0 2.01 0 4.5V10.5C0 12.98 2.01 15 4.5 15H10.5C12.98 15 15 12.98 15 10.5V4.5C15 2.01 12.98 0 10.5 0H4.5ZM4 7.5C4 5.56 5.56 4 7.5 4C9.43 4 11 5.56 11 7.5C11 9.43 9.43 11 7.5 11C5.56 11 4 9.43 4 7.5ZM11 4H12V3H11V4Z"
                  fill="#000"
                />
              </svg>
            </a>

            {/* Facebook */}
            <a
              href="https://www.facebook.com/people/Gradiance/61578338348942/"
              target="_blank"
              rel="noopener noreferrer"
              className="p-2 rounded-full bg-gray-200 hover:bg-orange-100 transition"
            >
              <svg
                fill="#000"
                width="28"
                height="28"
                viewBox="0 0 24 24"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path d="M20.9,2H3.1A1.1,1.1,0,0,0,2,3.1V20.9A1.1,1.1,0,0,0,3.1,22h9.58V14.25h-2.6v-3h2.6V9a3.64,3.64,0,0,1,3.88-4,20.26,20.26,0,0,1,2.33.12v2.7H17.3c-1.26,0-1.5.6-1.5,1.47v1.93h3l-.39,3H15.8V22h5.1A1.1,1.1,0,0,0,22,20.9V3.1A1.1,1.1,0,0,0,20.9,2Z" />
              </svg>
            </a>
          </div>
        </div>

        {/* Right: Contact Info */}
        <div className="text-center md:text-right">
          <h4 className="text-lg  font-semibold mb-3">Contact Us</h4>
          <div className="text-sm space-y-2">
            {[
              ["+91 63762 92470", "+916376292470"],
              ["+91 82334 31894", "+918233431894"],
            ].map(([label, link]) => (
              <div
                key={link}
                className="flex justify-center md:justify-end items-center gap-2"
              >
                <svg
                  className="w-4 h-4 text-gray-700"
                  fill="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path d="M6.62 10.79a15.91 15.91 0 0 0 6.59 6.59l2.2-2.2a1 1 0 0 1 1.05-.24c1.12.37 2.33.57 3.54.57a1 1 0 0 1 1 1V20a1 1 0 0 1-1 1c-9.39 0-17-7.61-17-17a1 1 0 0 1 1-1h3.5a1 1 0 0 1 1 1c0 1.21.2 2.42.57 3.54a1 1 0 0 1-.24 1.05l-2.2 2.2z" />
                </svg>
                <a
                  href={`tel:${link}`}
                  className="hover:text-orange-600 underline"
                >
                  {label}
                </a>
              </div>
            ))}
            <div className="flex justify-center md:justify-end items-center gap-2">
              <svg
                className="w-4 h-4 text-gray-700"
                fill="currentColor"
                viewBox="0 0 24 24"
              >
                <path d="M2 6a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V6zm3.519 0L12 11.671 18.481 6H5.52zM20 7.329l-7.341 6.424a1 1 0 0 1-1.318 0L4 7.329V18h16V7.329z" />
              </svg>
              <a
                href="mailto:gradiance.in@gmail.com"
                className="hover:text-orange-600 underline"
              >
                gradiance.in@gmail.com
              </a>
            </div>
          </div>
        </div>
      </div>

      {/* Bottom: Copyright */}
      <div className="pt-6 mt-10 border-t border-gray-200 text-xs text-center text-gray-500">
        &copy; {new Date().getFullYear()} Gradiance. All rights reserved.
      </div>
    </footer>
  );
};

const LandingPage = () => {
  return (

<div className="bg-white text-black font-sans">
  {/* Hero + Header */}
<section className="relative w-full overflow-hidden">

  {/* Responsive Banner */}
  <picture>
    <source
      media="(max-width: 767px)"
      srcSet="/staticImages/banner-mobile.png"
    />

    <img
      src="/staticImages/banner-pc.png"
      alt="Gradiance premium wall finishes"
      className="w-full h-auto block"
      loading="eager"
    />
  </picture>

  {/* Header */}
  <Header transparent />

</section>

  {/* Hero Content */}
  {/* <div className="absolute inset-0 z-20 flex items-center justify-center">
    <h1 className="text-2xl sm:text-4xl md:text-6xl font-light uppercase tracking-[0.2em] text-white whitespace-nowrap drop-shadow-2xl">
      Live the Luxury
    </h1>
  </div> */}

      <section className="py-12 sm:py-16 lg:py-20 px-6 bg-white">
        <div className="max-w-6xl mx-auto text-center">
          {/* HEADING */}
          <h2 className="text-3xl sm:text-4xl font-semibold tracking-wide leading-tight mb-4">
            About{" "}
            <span
              className="
        bg-gradient-to-r 
        from-blue-800 
        via-purple-600 
        via-pink-500 
        to-orange-400 
        bg-clip-text 
        text-transparent
      "
            >
              Gradiance
            </span>
          </h2>

          {/* TAGLINE */}
          <p className="text-gray-500 text-sm sm:text-base max-w-2xl mx-auto mb-8 sm:mb-10">
            High-quality finishes at prices that make sense
          </p>

          {/* MAIN CONTENT CARD */}
          <div
            className="
      bg-gradient-to-br from-gray-50 to-gray-100 
      border border-gray-200 
      rounded-2xl sm:rounded-3xl 
      p-6 sm:p-8 lg:p-10 
      shadow-md sm:shadow-lg
    "
          >
            <p className="text-gray-700 text-base sm:text-lg leading-relaxed max-w-3xl mx-auto">
              Gradiance is built on a simple promise - delivering
              premium-quality paints, wall care solutions, and
              construction-grade adhesives with premium quality. We
              focus on consistency, durability, and finish, ensuring every
              product performs reliably across homes and projects of all scales.
            </p>
          </div>
        </div>
      </section>

      {/* Product Highlights */}
      <section id="products">
        <ProductHighlights />
      </section>

      <section id="why" className="py-16 sm:py-20 px-6 bg-gray-50">
        <div className="max-w-6xl mx-auto text-center mb-12">
          {/* HEADING */}
          <h2 className="text-3xl sm:text-4xl font-semibold tracking-wide">
            Why Choose{" "}
            <span
              className="bg-gradient-to-r 
  from-blue-800 
  via-purple-600 
  via-pink-500 
  to-orange-400  bg-clip-text text-transparent"
            >
              Gradiance
            </span>
          </h2>

          {/* SUBTEXT */}
          <p className="mt-3 text-gray-500 text-sm sm:text-base max-w-2xl mx-auto">
            Built for quality, designed for value, trusted for results
          </p>
        </div>

        {/* CARDS */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 max-w-6xl mx-auto">
          {[
            {
              title: "Superior Quality",
              desc: "Consistent performance and long-lasting durability across all surfaces and conditions.",
            },
            {
              title: "Smooth Finish",
              desc: "Easy application with rich colors and a professional-grade finish every time.",
            },
            {
              title: "Smart Pricing",
              desc: "Premium results without premium pricing - built to deliver real value.",
            },
          ].map((point, index) => (
            <div
              key={index}
              className="group relative p-6 sm:p-8 rounded-2xl overflow-hidden
        bg-gradient-to-br from-[#020617] via-[#0f172a] to-[#020617]
        text-white border border-white/10
        shadow-[0_15px_50px_rgba(0,0,0,0.6)]
        hover:scale-[1.03]
        transition-all duration-500"
            >
              {/* Glow Effect */}
              <div className="absolute inset-0 bg-[radial-gradient(circle_at_top,rgba(255,255,255,0.08),transparent_60%)] opacity-60 pointer-events-none" />

              {/* ICON (Clean Circle instead of generic tick) */}
              <div
                className="w-10 h-10 mb-4 flex items-center justify-center rounded-lg 
bg-white/5 border border-white/10 text-sm font-semibold text-white/80"
              >
                {index + 1}
              </div>

              {/* TITLE */}
              <h3 className="text-lg sm:text-xl font-semibold mb-2">
                {point.title}
              </h3>

              {/* TEXT */}
              <p className="text-sm text-gray-300 leading-relaxed">
                {point.desc}
              </p>
            </div>
          ))}
        </div>
      </section>

      {/* Gallery Section */}
      <section id="gallery" className="px-4 bg-gray-50 relative">
        <div className="max-w-4xl mx-auto text-center mb-10">
          <h2 className="text-3xl font-semibold mb-2">Project Gallery</h2>
          <p className="text-gray-600 text-sm">
            A glimpse of our products in real environments
          </p>
        </div>

        <div
          className="relative grid grid-cols-4 gap-2 max-w-4xl mx-auto"
          style={{
            gridAutoRows: "130px",
            gridAutoFlow: "dense",
          }}
        >
          {[
            {
              src: "/staticImages/gallery/img1.jpg",
              span: "col-span-2 row-span-2",
            },
            { src: "/staticImages/gallery/img1.jpg", span: "" },
            { src: "/staticImages/gallery/img2.jpg", span: "" },
            { src: "/staticImages/gallery/img3.jpg", span: "" },
            { src: "/staticImages/gallery/img4.jpg", span: "row-span-2" },
            { src: "/staticImages/gallery/img5.jpg", span: "" },
            { src: "/staticImages/gallery/img6.jpg", span: "" },
            { src: "/staticImages/gallery/img7.jpg", span: "col-span-2" },
            { src: "/staticImages/gallery/img8.jpg", span: "" },
            { src: "/staticImages/gallery/img9.jpg", span: "" },
            { src: "/staticImages/gallery/img10.jpg", span: "" },
          ].map((img, index) => (
            <div
              key={index}
              className={`overflow-hidden rounded-lg shadow hover:shadow-md transition duration-300 ${img.span}`}
            >
              <img
                src={img.src}
                alt={`Gallery ${index + 1}`}
                className="w-full h-full object-cover"
                onError={(e) => (e.target.style.display = "none")}
                loading="lazy"
              />
            </div>
          ))}

          {/* CTA Overlay */}
          <div className="absolute inset-0 flex items-center justify-center pointer-events-none">
            <a
              href="/gallery"
              className="pointer-events-auto bg-white text-black px-5 py-2 rounded-full text-sm font-medium shadow hover:bg-gray-200 transition"
            >
              Explore Full Gallery
            </a>
          </div>
        </div>
      </section>

      <section id="contact">
        <ContactForm />
      </section>

      {/* Footer */}
      <Footer />
    </div>
  );
};

export default LandingPage;

export const ProductHighlights = () => {
  const featuredProducts = Array.isArray(products)
    ? products.filter((p) => p.highlight)
    : [];

  const otherProducts = Array.isArray(products)
    ? products.filter((p) => !p.highlight)
    : [];

  return (
    <section id="products" className="bg-gray-50 sm:py-14">
      {/* TITLE */}
      <div className="text-center mb-10 sm:mb-12">
        <h2 className="text-3xl sm:text-4xl font-semibold text-gray-900 tracking-wide">
          Premium Products
        </h2>

        <div className="mt-3 w-20 h-[3px] mx-auto bg-gradient-to-r from-blue-500 to-indigo-500 rounded-full"></div>
      </div>

      {/* PRODUCT IMAGE (BUCKETS) */}
      <div className="flex justify-center px-4 sm:px-6 mb-10 sm:mb-14">
        <img
          src="/staticImages/Products_Buckets.png"
          alt="Gradiance Products"
          className="
        w-full 
        max-w-6xl 
        h-auto 
        object-contain 
        drop-shadow-xl
        transition duration-500
        hover:scale-[1.02]
      "
        />
      </div>

      {/* FEATURED PRODUCTS */}
      <div className="max-w-7xl mx-auto px-4 sm:px-6">
        <div className="grid md:grid-cols-2 gap-6 sm:gap-10">
          {featuredProducts.map((product, index) => (
            <div
              key={index}
              className="group relative rounded-3xl p-6 sm:p-8 overflow-hidden
          bg-gradient-to-br from-[#020617] via-[#0f172a] to-[#020617] text-white
          border border-white/10
          shadow-[0_20px_60px_rgba(0,0,0,0.6)]
          hover:scale-[1.02] hover:shadow-[0_30px_80px_rgba(0,0,0,0.9)]
          transition-all duration-500"
            >
              {/* Glow */}
              <div
                className="absolute inset-0 pointer-events-none
            bg-[radial-gradient(circle_at_top,rgba(255,255,255,0.08),transparent_60%)]
            opacity-60"
              />

              {/* TOP */}
              <div className="flex items-center gap-4 sm:gap-6 mb-6 sm:mb-8 relative z-10">
                {/* IMAGE */}
                <div className="flex-shrink-0">
                  <img
                    src={product.image}
                    alt={product.name}
                    className="h-20 sm:h-28 object-contain
                drop-shadow-[0_10px_25px_rgba(255,255,255,0.25)]
                transition-transform duration-500 group-hover:scale-110"
                    onError={(e) => (e.target.style.display = "none")}
                  />
                </div>

                {/* TEXT */}
                <div className="flex-1">
                  <h3 className="text-lg sm:text-2xl font-bold tracking-wide mb-1">
                    {product.name}
                  </h3>

                  {product.sku && (
                    <p className="text-xs sm:text-sm text-gray-400 mb-1">
                      Pack Size:{" "}
                      <span className="text-white font-medium">
                        {product.sku}
                      </span>
                    </p>
                  )}

                  <p className="text-xs sm:text-sm text-gray-300 leading-relaxed">
                    {product.tagline}
                  </p>
                </div>
              </div>

              {/* VARIANTS */}
              <div className="relative z-10">
                <p className="font-semibold mb-4 sm:mb-5 text-xs sm:text-sm text-gray-300 text-center tracking-wide">
                  Available Variants
                </p>

                <div className="grid grid-cols-1 sm:grid-cols-2 gap-3 sm:gap-4">
                  {product.variants?.map((variant, i) => (
                    <div
                      key={i}
                      className="min-h-[100px] p-3 sm:p-4 rounded-xl
                  bg-white/5 border border-white/10
                  hover:bg-white/10 hover:border-white/20
                  hover:shadow-[0_0_20px_rgba(255,255,255,0.08)]
                  hover:scale-[1.03]
                  transition-all duration-300
                  flex flex-col items-center justify-center text-center"
                    >
                      <p className="text-base sm:text-lg font-semibold text-white mb-1">
                        {variant.name}
                      </p>

                      <p className="text-xs sm:text-sm text-gray-400 leading-relaxed line-clamp-2">
                        {variant.description}
                      </p>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* 🧱 OTHER PRODUCTS (SMALL CARDS) */}
      {otherProducts.length > 0 && (
        <div className="mt-20 px-6 max-w-7xl mx-auto">
          <h3 className="text-2xl font-semibold mb-10 text-center">
            More Products (Launching Soon)
          </h3>

          <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-8">
            {otherProducts.map((product, index) => (
              <div
                key={index}
                className="relative bg-white shadow-md rounded-2xl p-6 pt-10 text-center opacity-80"
              >
                {/* Overlay */}
                <div className="absolute inset-0 bg-white/40 backdrop-blur-[1px] rounded-2xl flex items-center justify-center">
                  <span className="px-5 py-1.5 text-xs font-medium text-white bg-black/70 rounded-full">
                    Coming Soon
                  </span>
                </div>

                {/* Image */}
                <img
                  src={product.image}
                  alt={product.name}
                  className="h-32 mb-3 mx-auto object-contain"
                  onError={(e) => (e.target.style.display = "none")}
                />

                <h4 className="text-lg font-bold">{product.name}</h4>
                <p className="text-sm text-gray-600">{product.tagline}</p>
              </div>
            ))}
          </div>
        </div>
      )}
    </section>
  );
};
